import { Link } from "react-router-dom";
import { LOGO_IMG } from "@/lib/brand";

export function LegalLayout({ title, updated, children, testid }) {
  return (
    <div className="min-h-screen bg-slate-50 text-navy-900" data-testid={testid}>
      <header className="bg-navy-950 text-white">
        <div className="max-w-4xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link to="/" data-testid="legal-home-link">
            <img src={LOGO_IMG} alt="Pinpoint Media Intelligence" className="h-10 w-auto bg-white rounded-md p-1.5" />
          </Link>
          <nav className="flex items-center gap-4 text-sm">
            <Link to="/privacy" className="hover:underline underline-offset-2" data-testid="nav-privacy-link">Privacy Policy</Link>
            <Link to="/terms" className="hover:underline underline-offset-2" data-testid="nav-terms-link">Terms of Service</Link>
          </nav>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="font-display text-3xl sm:text-4xl tracking-tight">{title}</h1>
        <p className="text-sm text-slate-500 mt-2 mb-10">Last updated: {updated}</p>
        <div className="prose prose-slate max-w-none space-y-6 text-[15px] leading-relaxed text-slate-700">
          {children}
        </div>
      </main>

      <footer className="border-t border-slate-200 bg-white">
        <div className="max-w-4xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-slate-500">
          <span>© {new Date().getFullYear()} Pinpoint Media Intelligence. All rights reserved.</span>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="hover:text-navy-900 hover:underline" data-testid="footer-privacy-link">Privacy Policy</Link>
            <span className="text-slate-300">•</span>
            <Link to="/terms" className="hover:text-navy-900 hover:underline" data-testid="footer-terms-link">Terms of Service</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

export const CONTACT = {
  name: "Pinpoint Media Intelligence (a brand of Kenneth Vincent Group LLC)",
  address: "210 Harmon Creek Road #1083, Kernersville, NC 27284",
  email: "info@getpmi.com",
};

export function H2({ children }) {
  return <h2 className="font-display text-xl text-navy-900 mt-8 mb-2">{children}</h2>;
}
